import React, { useMemo } from 'react';
import { FormGroup, FormControl, ControlLabel, Collapse, Badge } from 'react-bootstrap';
import PropTypes from 'prop-types';

import Translations from '../../../../../../../components/Collapse/Translations';

const FieldsName = ({ isOpenTranslations, item, defaultLanguage, languages, setOpenTranslations }) => {
  const defaultLang = useMemo(() => {
    const finded = languages?.find((language) => language.code === defaultLanguage);
    return {
      ...finded,
      value: item?.details?.name?.[finded?.code],
    };
  }, [defaultLanguage, item.details.name, languages]);
  const anotherLanguages = useMemo(
    () => languages
      ?.filter((language) => language.code !== defaultLanguage)
      ?.map((language) => ({ ...language, value: item?.details?.name?.[language.code] })),
    [defaultLanguage, item.details.name, languages],
  );

  return (
    <>
      <FormGroup>
        <ControlLabel htmlFor={`${defaultLang?.code}`}>
          Method name
          {' '}
          <Badge>{defaultLang?.name}</Badge>
        </ControlLabel>
        <Translations onOpen={() => setOpenTranslations(!isOpenTranslations)} open={isOpenTranslations} items={languages}>
          <FormControl
            type="text"
            id={`${defaultLang?.code}`}
            name={`name[${defaultLang?.code}]`}
            defaultValue={defaultLang.value || ''}
            autoFocus
            required
          />
        </Translations>
      </FormGroup>
      <Collapse in={isOpenTranslations} mountOnEnter>
        <div>
          {anotherLanguages?.length
            ? anotherLanguages?.map((language) => (
              <div key={`${language?.code}`}>
                <FormGroup>
                  <ControlLabel htmlFor={`${language?.code}`}>
                    Method name
                    {' '}
                    <Badge>{language?.name}</Badge>
                  </ControlLabel>
                  <FormControl type="text" id={`${language?.code}`} name={`name[${language?.code}]`} defaultValue={language.value || ''} />
                </FormGroup>
              </div>
            ))
            : null}
        </div>
      </Collapse>
    </>
  );
};

FieldsName.propTypes = {
  isOpenTranslations: PropTypes.bool,
  item: PropTypes.object,
  defaultLanguage: PropTypes.string,
  languages: PropTypes.array,
  setOpenTranslations: PropTypes.func,
};

export default FieldsName;
